import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeLeadingZeros',
  standalone: true
})
export class RemoveLeadingZerosPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return value || '';
    return value.replace(/^0+(?=[A-Z])/, '');
  }
}
